import SidebarFilters from "./sidebar-filters.container";

export default SidebarFilters;
